
import { FC, PropsWithChildren, useMemo, useState } from 'react';
import { DefaultLotCreateLink, DefaultProjectCreateLink, DefaultStageCreateLink, ILinkContext, LinkContext } from '../../../contexts/layouts/LinkContext';



interface ILinkProviderProps { }

const LinkProvider: FC<PropsWithChildren<ILinkProviderProps>> = ({ 
    children 
}) => {
    const [projectLinkEnabled, setProjectLinkEnabled] = useState<ILinkContext['projectLinkEnabled']>(true);
    const [createProjectLink, setCreateProjectLink] = useState<ILinkContext['createProjectLink']>(() => DefaultProjectCreateLink);
    const [stageLinkEnabled, setStageLinkEnabled] = useState<ILinkContext['stageLinkEnabled']>(true);
    const [createStageLink, setCreateStageLink] = useState<ILinkContext['createStageLink']>(() => DefaultStageCreateLink);
    const [lotLinkEnabled, setLotLinkEnabled] = useState<ILinkContext['lotLinkEnabled']>(true);
    const [createLotLink, setCreateLotLink] = useState<ILinkContext['createLotLink']>(() => DefaultLotCreateLink);

    const context = useMemo(() => {
        return {
            projectLinkEnabled , 
            setProjectLinkEnabled:  (enabled?: ILinkContext['projectLinkEnabled']) => {
                if (enabled === undefined) {
                    setProjectLinkEnabled(() => true);
                }
                else {
                    setProjectLinkEnabled(() => enabled);
                }
            },
            stageLinkEnabled, 
            setStageLinkEnabled:  (enabled?: ILinkContext['stageLinkEnabled']) => {
                if (enabled === undefined) {
                    setStageLinkEnabled(() => true);
                }
                else {
                    setStageLinkEnabled(() => enabled);
                }
            },
            lotLinkEnabled, 
            setLotLinkEnabled:  (enabled?: ILinkContext['lotLinkEnabled']) => {
                if (enabled === undefined) {
                    setLotLinkEnabled(() => true);
                }
                else {
                    setLotLinkEnabled(() => enabled);
                }
            },

            createProjectLink: createProjectLink,
            setCreateProjectLink: (createLinkFn?: ILinkContext['createProjectLink']) => {
                if (!createLinkFn) {
                    setCreateProjectLink(() => DefaultProjectCreateLink);
                }
                else {
                    setCreateProjectLink(() => createLinkFn);
                }
            },

            createStageLink: createStageLink,
            setCreateStageLink: (createLinkFn?: ILinkContext['createStageLink']) => {
                if (!createLinkFn) {
                    setCreateStageLink(() => DefaultStageCreateLink);
                }
                else {
                    setCreateStageLink(() => createLinkFn);
                }
            },

            createLotLink: createLotLink,
            setCreateLotLink: (createLinkFn?: ILinkContext['createLotLink']) => {
                if (!createLinkFn) {
                    setCreateLotLink(() => DefaultLotCreateLink);
                }
                else {
                    setCreateLotLink(() => createLinkFn);
                }
            }
        }
    }, [
        createProjectLink, 
        setCreateProjectLink,
        createStageLink, 
        setCreateStageLink, 
        createLotLink, 
        setCreateLotLink, 
        projectLinkEnabled, 
        setProjectLinkEnabled,
        stageLinkEnabled, 
        setStageLinkEnabled,
        lotLinkEnabled, 
        setLotLinkEnabled,
    ])

    return (
        <LinkContext.Provider value={context}>
            {children}
        </LinkContext.Provider>
    )
}

export default LinkProvider;